/**
 * Created by Abner Sui on 10/23/2020.
 * Description:
 *
 * ------ maintenance history ------
 * 11/10/2021 Simon Zhao replaced the delimiter with the one defined in workflow service and attached the extra config before formatting value with the configured format.
 * 1/6/2022 Simon Zhao added the support for the usage in the bottom grid in the instance kanban grid view.
 * Updated by Daniel Wang on 4/3/2023, to handle the number fields which are not started.
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProcessInstance } from '../../../tamalelibs/models/workflow.model';
import { COLUMN_ID_DELIMITER, FIX_FORMAT_AGG_FUNCTIONS, NUMBER_FORMAT_ATTRIB, SOURCE_GRID, WorkflowService } from '../../../tamalelibs/services/workflow.service';
import { Task } from './../../../tamalelibs/models/workflow.model';

@Component({
    selector: 'tam-number-info-aggrid',
    templateUrl: './number-info-aggrid.component.html',
    styleUrls: ['./number-info-aggrid.component.scss']
})
export class NumberInfoAggridComponent implements ICellRendererAngularComp {

    value: any;
    format: any;
    isNotStartTaskField = false;

    constructor(
        private _workflowService: WorkflowService,
    ) { }

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        this.value = params.value;
        const fieldDefinitionId = params['fieldDefinitionId'];
        const taskDefinitionId = params['taskDefinitionId'];
        this.isNotStartTaskField = this._workflowService.isNotStartTaskFieldForInputTask(fieldDefinitionId, taskDefinitionId, params.data);
        const instance: ProcessInstance = params.data;
        const colDef = params.colDef;
        if (instance && instance.task) {
            const ids = colDef.colId.split(COLUMN_ID_DELIMITER);
            if (ids.length === 2) {
                const taskDefId = ids[0];
                const fieldId = ids[1];
                const task = instance.task.find(item => Task.isManualTask(item) && item.taskDefinition.id === taskDefId);

                if (task) {
                    this._workflowService.attachFieldConfigFromTemplate(task);
                    const field = task.fields.get(fieldId);
                    if (field) {
                        this.format = this._workflowService.getFormatForNumber(field);
                    }
                }
            }
        } else {
            if (!!colDef && colDef.colId && colDef[SOURCE_GRID]) {
                // handle the aggregational cell's rendering in the instance view grid of workflow page.
                if (colDef.aggFunc && !!this.value) {
                    // the column to which the aggregation function is being applied.
                    const numberFormat = colDef[NUMBER_FORMAT_ATTRIB];
                    if (numberFormat) {
                        const fixedFormat = FIX_FORMAT_AGG_FUNCTIONS[colDef.aggFunc.toString()];
                        if (!fixedFormat) {
                            // the aggregation function the format should be applied.
                            this.format = numberFormat;
                        } else {
                            // Use the fixed format such as count
                            this.format = fixedFormat;
                        }
                    }
                }
            } else {
                if (!this.value) {
                    this.value = 0;
                }
            }
        }
    }

}
